import {_transl} from "../../../../../store/localization/TranslMessasge";
import {HierarchyTreeTranslationKey} from "../HierarchyTreeTranslationKey";
import React from "react";
import DeleteConfirmationDialog from "../../../../../components/dialogs/DeleteConfirmationDialog";

export interface HierarchyTreeDeleteDialogProps {
    open: boolean;
    treeId?: string;
    onConfirm: (treeId: string) => void;
    onCancel: () => void;
}

export function HierarchyTreeDeleteDialog({open, treeId, onConfirm, onCancel}: HierarchyTreeDeleteDialogProps) {
    return (
        <DeleteConfirmationDialog open={open}
                                  title={_transl(HierarchyTreeTranslationKey.STRUCTURE_DELETE_QUESTION_MARK)}
                                  message={_transl(HierarchyTreeTranslationKey.STRUCTURE_DELETE_CONSEQUENCE)}
                                  onDelete={() => onConfirm(treeId!)}
                                  onDismiss={() => onCancel()} />
    );
}
